module.exports = __webpack_public_path__ + "static/media/02-mainmenu.df297d7f.png";